module.exports = __webpack_public_path__ + "static/img/img-banner3.260bb932.gif";